import axios from "axios";
import moment from "moment";
import publicIp from 'public-ip';
import { useSelector } from "react-redux";

import Cookies from 'js-cookie'




export const shortAsc = (data1) => {
    data1.sort((a, b) => {
        var a1 = a.title.toLowerCase();
        var b1 = b.title.toLowerCase();

        if (a1 > b1) {
            return 1
        } else
        if (a1 < b1) {
            return -1
        } else {
            return 0
        }
    })
    return data1;
}


export const stripTags = (original) => {
    var text = original?.replace(/(<([^>]+)>)/gi, "");
    return text?.replace("&amp;", "&");
}


export const wordLimit = (content = '', limit = '') => {
    // var str = "splits a string into an array of substrings, and returns the array.";
    let contentArray = content.split(' ');
    contentArray = contentArray.slice(0, limit);
    if (contentArray != '') {
        contentArray = contentArray.join(' ').concat('...');
    }
    return contentArray;

}




export const mediaInput = {
    "userid": 1,
    "videoCode": "",
    "videoId": "",
    "videoType": "",
    "videoTitle": "",
    "videoDescription": "",
    "DocumentType": "Common",
    "isPinned" : "",
    "groupId":"",
    "group_name": "",
    "isFeatured": true,
    "item_order":"1",   
    "inputType": 2
  }


export const dateFormat = (str, format) => {
    return moment(str, 'DD-MM-YYYY HH:mm:ss', true).format('DD-MMM-YYYY HH:mm:ss');
}


export const loggedInAdmin = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

export const loggedInUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

export const showCalendarActionBtn = () => {
    var usersArr = ["3", "17", "4"];
    if(usersArr.includes(loggedInAdmin?.UserID)){
        return true
    } else {
        return false
    };
}


// export const watermarkText = `Vineet Kumar ${localStorage.getItem('ipData') ? JSON.parse(localStorage.getItem('ipData'))?.IPv4 : null}`;
const uName = `${localStorage.getItem('users_leggin') ? JSON.parse(localStorage.getItem('users_leggin'))?.email : 'vineet@omkaracapital.in'}`;
export const watermarkText = uName;
// export const watermarkText = `${uName} ${localStorage.getItem('ipData') ? JSON.parse(localStorage.getItem('ipData'))?.IPv4 : null}`;
// export const watermarkText = `UserName ${JSON.parse(localStorage.getItem('ipData'))?.IPv4}`;


export const convertToSlug = (Text) => {
    return Text.toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '')
}

export const encodeBtoa = (str) => {
    return window.btoa(str)
}

export const decodeAtob = (str) => {
    return window.atob(str)
}

export const rangeArray = (start, end) => {
    return Array(end - start + 1).fill().map((_, idx) => start + idx)
}



export const DataRoomDocumentType = [
    { title: 'None', value: '0' },
    { title: 'Annual Reports', value: 'Annual Reports' },
    { title: 'Concall Transcripts', value: 'Concall Transcripts' },
    { title: 'Forensic', value: 'Forensic' },
    { title: 'Initial Coverage', value: 'Initial Coverage' },
    { title: 'Investor Presentation', value: 'Investor Presentation' },
    { title: 'Others', value: 'Others' },
    { title: 'Quarterly Update', value: 'Quarterly Update' },
];

export const DocumentNotes = [
    { title: 'None', value: '0' },
    { title: 'Quarter Update', value: 'Quarter Update' },
    { title: 'Management Meeting', value: 'Management Meeting' },
    { title: 'One Pager', value: 'One Pager' },
    { title: 'Important Source', value: 'Important Source' },
    { title: 'Rough', value: 'Rough' },
];

export const DocumentType = [
    { title: 'None', value: '0' },
    { title: 'Research Report', value: 'Research Report' },
    { title: 'Sector Report', value: 'Sector Report' },
    { title: 'Quarterly Updates', value: 'Quarterly Updates' },
    { title: 'Running Notes (WIP)', value: 'Running Notes (WIP)' },
    { title: 'Stock Exchange Announcements', value: 'Stock Exchange Announcements' },
];

export const ideaType = [
    { title: 'None', value: '0' },
    { title: 'Tactical', value: '1' },
    { title: 'Long Term', value: '2' },
    // { title: 'Under Study', value: '3' },
];


export const recommendationArr = [
    { title: 'None', value: '0', color: '' },
    { title: 'Buy', value: '1', color: 'Green' },
    { title: 'Sell', value: '2', color: 'Red' },
    { title: 'Hold', value: '3', color: 'orange' },
    { title: 'Under Study', value: '4', color: '#004e8f' },
    { title: 'Under Review', value: '5', color: '#C2A560' },
];




export const recommendationType = (values) => {
    return recommendationArr[values];
};



export const ideaTypeTitle = (values) => {
    return ideaType[values].title;
};


const getSingleGroupData = (data, group_id) => {
    data.find(obj => {
        return obj.group_id === group_id
    })
}


export const userAuth = () => {
    if(localStorage.getItem('user') !== '' && localStorage.getItem('token') !== ''){
        return true;
    }
    return false;
}


const LIVE_SITE_URL = 'https://omkaracapital.in';
export const checkUser = async () => {
    await axios.get(`${LIVE_SITE_URL}/sanctum/csrf-cookie`).then(response => {
        var token = Cookies.get('auth_token');
        // console.log(token);
        axios.get(`${LIVE_SITE_URL}/api/profile`, {
            headers: { "Authorization": `Bearer ${token}` }
        }).then(res => {
            if (res.data.type === 'Subscription_User') {
                localStorage.setItem('users_leggin', JSON.stringify(res.data));
                Cookies.set('user_leggin', JSON.stringify(res.data), { expires: 1 });
            } else {
                if( window.location.host === 'vdr.omkaracapital.in'){
                    window.location.href = `${LIVE_SITE_URL}/user/login`
                }
            }

        }).catch(err => {
            if( window.location.host === 'vdr.omkaracapital.in'){
                window.location.href = `${LIVE_SITE_URL}/user/login?next=${window.location.href}`;
            }
            // console.log('err',err)
            // window.location.href = `${LIVE_SITE_URL}/user/login?next=${window.location.href}`;
        });
    })
}


export const getFirstChar = (str) => {
    // return "str";
    console.log("str", str);
    if(str){
        return str.charAt(0).toLocaleUpperCase();
    }
}
// vimeo_parser
// youtube_parser

export const vimeo_parser = (url) => {
    // var url = "http://www.vimeo.com/7058755"; //Or any other Vimeo url format
    var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
    let unlisted_code = "";
    var match = url.match(regExp);
    var ddArr = url.split('/');
    if(ddArr.length == 5){
        unlisted_code = '/'+ddArr[ddArr.length-1]

    }
    // console.table(match);
    if (match) {
        return match[5]+unlisted_code;
    } else {
        // alert("not a vimeo url");
        return null;
    }
}

export const youtube_parser = (url) => {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length == 11) ? match[7] : null;
}




export const getForensicUpdateTitle = (title="", type="") => {
    // return "000000000";
    let CTitle = '';
    let n_title = '';
    let c_type = '';

    if(type == 'DH'){
        CTitle = 'Dividend History';
    }
    if(type == 'AH'){
        CTitle = 'Auditor History';
    }
    if(type == 'SH'){
        CTitle = 'Shareholding Pattern';
    }
    if(type == 'ESOP'){
        CTitle = 'ESOP';
    }
    if(type == 'CH'){
        CTitle = 'Capital History';
    }

    if(type == 'ratios'){
        CTitle = 'ratios';
    }

    if(title && type != 'SH'){
        n_title = title;
        c_type = n_title;
    }else{
        n_title = CTitle;
        c_type = type;
    }

    return {
        title:n_title,
        type:c_type,
    }

}



// export const openSingleCompany = async (rowData, tableInstance1, CompanyName, type = '_blank') => {
//     localStorage.setItem('companyId', rowData.CompanyID);
//     localStorage.setItem('companyName', CompanyName);
//     localStorage.setItem('openedCompany', rowData.CompanyID);
//     // tableInstance1.current.click();
//     return openInNewTab(`${domainUrl}/${linkBaseUrlData}/single-company.html`, type);
//   }

  export const getBaseLink = () => {
    let baseLink = "/client";
    return baseLink;
  }